import { render, staticRenderFns } from "./addPane.vue?vue&type=template&id=06bf5a65"
import script from "./addPane.vue?vue&type=script&lang=js"
export * from "./addPane.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports